import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableHead, TableRow, TableCell } from '@mui/material';

const ProductCommentListTableHeaderV2: React.FC = () => {
    const { t } = useTranslation();
    return (
        <TableHead>
            <TableRow>
                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '6%',
                                    }}
                                >
                                    <b>ID</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '10%',
                                    }}
                                >
                                    <b>{t('productCommentList.brandSpecialColor')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '13%',
                                    }}
                                >
                                    <b>{t('general.email')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '5%',
                                    }}
                                >
                                    <b>{t('productCommentList.victimization')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '7%',
                                    }}
                                >
                                    <b>{t('productCommentList.transactioner')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '9%',
                                    }}
                                >
                                    <b>{t('productCommentList.commentDate')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '10%',
                                    }}
                                >
                                    <b>{t('productCommentList.tag')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '6%',
                                    }}
                                >
                                    <b>{t('productCommentList.isAgent')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '6%',
                                    }}
                                >
                                    <b>{t('productCommentList.threshold')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '5%',
                                    }}
                                >
                                    <b>{t('productCommentList.labelValue')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '5%',
                                    }}
                                >
                                    <b>{t('productCommentList.photoComment')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '8%',
                                    }}
                                >
                                    <b>{t('productCommentList.status')}</b>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        textAlign: 'center',
                                        width: '4%',
                                    }}
                                >
                                    <b>{t('general.detail')}</b>
                                </TableCell>
                <TableCell
                    style={{
                        borderBottom: 'none',
                        textAlign: 'center',
                        width: '6%',
                    }}
                >
                    <b>{t('general.assignToMe')}</b>
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default ProductCommentListTableHeaderV2;
